module.exports = __webpack_public_path__ + "static/media/abbreviations.3ac82b3b.png";